/* eslint-disable react/jsx-pascal-case */
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../css/RecruitmentCard.css' ;
// import RrecuitmentTooltip from './RrecuitmentTooltip';
import Text from '../../../common/Text.js';
import Pagination from '../../Common/Component/Pagination.js';

//Recruit List Component
function RecruitmentCard() {
    const [allRecruitments, setAllRecruitments] = useState([]);
    const [filteredRecruitments, setFilteredRecruitments] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchCategory, setSearchCategory] = useState("all");

    const [page, setPage] = useState(1); //첫페이지를 몇번으로 할건지
    const [limit, setlimit] = useState(12); //한페이지단 보여줄 데이터개수
    const [total, setTotal] = useState(filteredRecruitments.length); // 선택할 몇개까지 나타낼건지
    const offset = (page -1) * limit; //전체 행개수로 카드분배
    const recruitments = filteredRecruitments.slice(offset, offset + limit); //페이지 번호별 카드갯수 나누기

    const [isLoggedIn, setIsLoggedIn] = useState(false);  //관리자인지
    
    //navigate 
    const navigate = useNavigate();
    const handleCardClick = (seq) => {
        console.log(seq);
        navigate('/RecruitmentDetail', {
            state: {
                cardkey: seq
            },
        });
    };

    useEffect ( () => {
        if(!isLoggedIn)
            {
                axios.post('/sessionCheck')
                .then((res) => {
                    if(res.data=='인증완료')
                        {
                            setIsLoggedIn(true);
                        }
                    else
                        {
                            setIsLoggedIn(false);
                        }
                })
            }
        getRecruitData();
        
    }, []);

    //메인데이터 가져오기
    const getRecruitData = async () => {
         axios.get('/api/RecruitMainSelect')
        .then(response => {
            setAllRecruitments(response.data);
            console.log('가져오기');
            console.log(response.data);
            setFilteredRecruitments(response.data);
            setTotal(response.data.length);
        })
        .catch(error => console.error("DB 가져오기 오류", error));
    }

    //검색필터
    const handleSearch = () => {
        let filtered = allRecruitments;
        //제목+내용
        if (searchCategory === 'all') {
            filtered = allRecruitments.filter(recruitment =>
                recruitment.Noti_title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Experience.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Dept.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Preferred.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Required.toLowerCase().includes(searchTerm.toLowerCase())
            );
        //제목
        } else if (searchCategory === 'title') {
            filtered = allRecruitments.filter(recruitment =>
                recruitment.Noti_title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        //내용
        } else if (searchCategory === 'content') {
            filtered = allRecruitments.filter(recruitment =>
                recruitment.Experience.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Dept.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Preferred.toLowerCase().includes(searchTerm.toLowerCase()) ||
                recruitment.Required.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setFilteredRecruitments(filtered);
        setTotal(filtered.length);
;    }

    //엔터키로 검색
    const handleSearchEnter = (e) => {
        if(e.key === "Enter") {
            handleSearch();
        }
      }

    //관리자 신규 클릭이벤트
    const handleNewClick = () => {
        navigate('/Recruit', {
            state: { 
                cardkey: '',
                mode: 'new'
            },});
    };
    return (
        <div >
            <div className='recruit-root'>
                    {/* <div className='recruit-container'> */}
                    <Text variant='titlename'>
                        <div className='HeaderParent'>
                            <div className='Header'>채용공고</div>
                        </div>
                    </Text>

                        {isLoggedIn &&
                            <button className='btnAdmin' onClick={() => handleNewClick()}>
                            신규생성
                            </button>
                        }

                        <div className='recruit-list-wrapper'>
                        <div className='recruit-list'>
                        {recruitments.map((recruitment, index) => {
                            const prefer = recruitment.Preferred && recruitment.Preferred.split(';');
                            const require = recruitment.Required && recruitment.Required.split(';');
                                return <div  className='recruit-card' onClick={() => handleCardClick(recruitment.Seq)}> 
                                    {/* 모집 중/모집 완료 */}
                                    <div className='statuss'>
                                        <Text variant="px16w400" className={`status ${recruitment.Status}`}>{recruitment.Status === 'active' ? '진행중' : '모집 완료'}</Text>
                                    </div>

                                    {/* 채용공고 제목 */}
                                    <Text variant="px24w600_rec">
                                        {recruitment.Status === 'active' && (
                                            <div className='noti_title active'>{recruitment.Noti_title}</div>
                                        )}
                                        {recruitment.Status !== 'active' && (
                                            <div className='noti_title close'>{recruitment.Noti_title}</div>
                                        )}
                                    </Text>
                                    {/* 채용 부서 */}
                                    {/* <Text variant="text-16px400w">
                                        <div className='dept'>{recruitment.Dept}</div>
                                    </Text> */}
                                    <Text variant="px18w400" className='dept'>{recruitment.Dept}</Text>
                                    
                                    {/* 채용 조건 (필수 주황색/우대 흰색) */}
                                    <div className='conditions_container'>
                                        <div className='conditions'>
                                        {require && require.map((req, index) => 
                                            <div>
                                                {recruitment.Status === 'active' && (
                                                    <Text variant='text-16px300w' className='condition-badge required'>{req}</Text>
                                                )}
                                                {recruitment.Status !== 'active' && (
                                                    <Text variant='text-16px300w' className='condition-badge closed'>{req}</Text>
                                                )}
                                            </div>
                                        )}
                                        {prefer && prefer.map((pre, index) => (
                                            <div className='condition-badge preferred'>{pre}</div>
                                        ))}

                                        </div>
                                    </div>
                                    {/* 경력,신입|yyyy.nn.dd ~ 모집완료시 */}
                                    <Text variant="px14">
                                        {recruitment.Status === 'active' && ( 
                                            <div className='experience active'>{recruitment.Experience} | {recruitment.Noti_dt} ~{' '}  {recruitment.Seq === 67 ? '2026.07.17' : '모집 완료 시'}</div>
                                        )}
                                        {recruitment.Status !== 'active' && (
                                            <div className='experience close'>{recruitment.Experience} | {recruitment.Noti_dt} ~{' '}  {recruitment.Seq === 67 ? '2026.07.17' : '모집 완료 시'}</div>
                                        )}
                                    </Text>
                                </div>

                        })}
                        </div>
                        </div>

                    {/* </div> */}
            </div>
            {/* 페이지네이션 */}
            <div style={{ display : 'flex', flexDirection: 'column', justifyContent : 'center', alignItems:"center", height :"200px", margin : '0px 0 0 0px'}}>
                {filteredRecruitments.length >=1 &&
                                <Pagination
                                total = {total}
                                limit = {limit}
                                page={page}
                                setPage={setPage}
                                />
                }

            </div>
            {/* 검색 */}
            <div className='Recruitsearch-container'>
                <div className='Recruittype-container'>
                    <select className='Recruittype'  value={searchCategory} onChange={e => setSearchCategory(e.target.value)}>
                        <option value="title"> 제목</option>
                        <option value="content"> 내용</option>
                        <option value="all"> 제목 + 내용</option>
                    </select>
                </div>

                <div className='RecruitinputBrd'>
                    <input className='Recruitinput'
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    onKeyDown={e => handleSearchEnter(e)}>
                    </input>
                </div>
                <button className='btnSearch' onClick={handleSearch}>
                    <Text variant="px18">검색</Text>
                </button>
            </div>

        </div>
    );
}

export default RecruitmentCard;

 